/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function openMegaMenu($object) {
	if ($(window).width() < 992) {
		return false;
	}

	// Close any open menus before opening this one
	closeMegaMenu();

	var $megamenuBg = $('.megamenu-bg');
	var $megamenuCaret = $('.megamenu-caret');
	var $currentPanel = $object.children('.sub-menu');

	if ( 0 === $currentPanel.length ) {
		return false;
	}

	// Get the dimensions and position of the current panel
	var width = $currentPanel.outerWidth();
	var height = $currentPanel.outerHeight();
	var panelPosition = $currentPanel.offset();

	// Get the width of the current link
	var $currentLink = $object.children('.nav-link-wrapper').children('a:first-child');
	var currentLinkWidth = $currentLink.outerWidth();
	var currentLinkPosition = $currentLink.offset();

	var caretPosition = currentLinkPosition.left - panelPosition.left + (currentLinkWidth / 2);

	$megamenuBg.css({'width': width, 'height': height, 'left': panelPosition.left}).addClass('megamenu-bg--isVisible');
	$megamenuCaret.css({'transform': 'translate(' + caretPosition + 'px, 0)'});
	$object.addClass('menu-item-active');
}

function closeMegaMenu() {
	var $megamenuBg = $('.megamenu-bg');
	$megamenuBg.removeClass('megamenu-bg--isVisible');
	$('.navbar-nav > li').removeClass('menu-item-active');
}

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {
				// JavaScript to be fired on all pages
				(function (p, l, o, w, i, n, g) {
					if (!p[i]) {
						p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
						p.GlobalSnowplowNamespace.push(i);
						p[i] = function () {
							(p[i].q = p[i].q || []).push(arguments)
						};
						p[i].q = p[i].q || [];
						n = l.createElement(o);
						g = l.getElementsByTagName(o)[0];
						n.async = 1;
						n.src = w;
						g.parentNode.insertBefore(n, g)
					}
				}(window, document, 'script', '//d28wynmo49l9mm.cloudfront.net/sp-2.9.2.js', 'snowplow'));

				document.onreadystatechange = function () {
					if (document.readyState === 'complete') {
						var appId = 'credible-blog';

						window.snowplow('newTracker', 'default', 'analytics.credible.com', {
							appId: appId,
							platform: 'web',
							cookieDomain: '.credible.com',
							contexts: {
								webPage: true,
								performanceTiming: true,
								gaCookies: true
							},
							post: true
						})

						var userId = document.cookie
							.split(';')
							.filter(function (cookie) {
								return cookie.replace(/(=.*)/, '') === 'user_id'
							})

						var uuid = (userId.length && userId[0].replace(/(.*=)/, '')) || null

						console.log('Snowplow initialized for : ', appId)

						window.snowplow('enableActivityTracking', 30, 10);
						window.snowplow('setUserId', uuid);
						window.snowplow('trackPageView');

						console.log('Snowplow track pageview ', uuid)
					}
				}

				navbarScrollhide();

				// position:sticky polyfill
				$('.sharedaddy, .sticky_top, .widget_sticky').Stickyfill();

				// Global utility
				// I hope this isn't expensive
				$('body')
					.on('click', '.preventDefault', function (e) {
						e.preventDefault();
					})
					.on('touchstart', function (e) {

						if ($(window).width() < 992) {
							return false;
						}
						closeMegaMenu();
					})
					.on('touchstart', function (e) {

						if ($(window).width() > 992) {
							return false;
						}
						if (e.target.closest('.navbar-toggler') || e.target.closest('#nav-column')) {
							return;
						}

						if ( $('body').hasClass('main-menu-open') ) {
							$('.navbar-toggler').trigger('click');
						}
					});

				// Navbar listeners
				$('#navbar')
				// Toggle logo dropdown
					.on('click', 'a.navbar-brand', function () {
						var $logo_dropdown = $('#logo-dropdown');
						if ($logo_dropdown.length > 0) {
							$('#logo-dropdown').toggleClass('active');
							return false;
						}
					})

					.on('click', '.navbar-toggler', function (e) {
						e.preventDefault();
						e.stopImmediatePropagation();
						$(this).toggleClass('collapsed');
						$('body').toggleClass('main-menu-open');
					})

					// Close logo dropdown
					.on('click', '#close-logo-dropdown', function () {
						$('#logo-dropdown').removeClass('active');
						return false;
					})

					// Toggle search in nav
					.on('mousedown', '#toggle-search', function () {

						var $navbar_search_query = $('#navbar-search-query');
						$navbar_search_query.toggleClass('active');

						if ($navbar_search_query.hasClass('active')) {
							$navbar_search_query.find('input').focus();
						}

						return false;
					})
					.on('click', '#toggle-search', function () {
						return false;
					})

					.on('mouseenter touchstart', '.navbar-nav > li', function (e) {
						openMegaMenu($(this));
					})
					.on('focus', '.navbar-nav > li li', function (e) {
						openMegaMenu($(this).parents('li.menu-item-has-children'));
					})

					.on('touchstart', '.navbar-nav > li', function (e) {
						e.stopPropagation(); // Prevent this event from reaching 'body', so that we can close the megamenu on any body touchstart event.
					})

					.on('mouseleave', '.navbar-nav > li', function () {
						closeMegaMenu();
					})
					.on('blur', '.navbar-nav > li li', function (e) {
						closeMegaMenu();
					})

					// Hide search when clicked outside
					.on('blur', '#navbar-search-query input', function () {
						$('#navbar-search-query').removeClass('active');
					})

					// Toggle dropdowns on mobile menu
					.on('click', '.menu-item-has-children > .nav-link-wrapper a.nav-link:first-child', function () {
						// If this doesn't have a "href" attribute, trigger a click on the next a.open-sub-menu
						var href = $(this).attr('href');
						if (typeof href === 'undefined' || href === false) {
							var toggleLink = $(this).next('.open-sub-menu');
							if (toggleLink.is(':visible')) {
								toggleLink.trigger('click');
							}
						}
					})

					.on('click', '.menu-item-has-children > .nav-link-wrapper a.open-sub-menu', function (e) {

						// If this is not open already, then close all other open sub-menus.
						if (!$(this).hasClass('sub-menu-open')) {
							$('.open-sub-menu.nav-link.sub-menu-open').removeClass('sub-menu-open');
						}
						$('.navbar-nav > li > ul.sub-menu').height(0); // Only set the height for sub-menus that are children of the top-level items.

						$(this).toggleClass('sub-menu-open');

						var $submenu = $(this).parent().next('ul.sub-menu');
						var total_height = 0;

						if ($submenu.outerHeight() === 0) {
							$submenu.children('li').each(function () {
								total_height += $(this).outerHeight();
							});
							$submenu.height(total_height);
						}

						return false;
					});

				// Create extra anchor for mobile menu dropdowns
				$('#navbar .nav-link').wrap('<div class="nav-link-wrapper"></div>');
				$('#navbar .sub-menu').prev().append('<a href="#" aria-label="Open sub-menu" class="open-sub-menu nav-link"><span class="icon"></span></a>');

				// Main menu collapse listener
				$('#main-menu')
					.on('show.bs.collapse', function () {
						$('html, body').addClass('main-menu-open');
					})
					.on('hidden.bs.collapse', function () {
						$('html, body').removeClass('main-menu-open');
					});

				// Swipe support on carousel in jumbotron
				/*$('#jumbosel')
					.swiperight(function () {
						$(this).carousel('prev');
					})
					.swipeleft(function () {
						$(this).carousel('next');
					});*/

				// Turn on bootstrap tooltips (what?)
				$('[data-toggle="tooltip"]').tooltip();

				// Move chapters widget above content on mobile
				$('.widget_chapters_widget').clone().prependTo('.col-entry');

				$('a.entry-meta__tooltip').on('click', function(event) {
					if ($(window).width() < 992) {
						event.preventDefault();
					}
				});

			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page
			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		'single': {
			init: function () {
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
